<template>
  <van-dialog
    v-model:show="showDialog"
    :close-on-click-overlay="true"
    :confirm="handelConfirm"
    :show-confirm-button="false"
    :title="'领取' + (selectItem && selectItem.ProdName)"
  >
    <div class="free-class">
      <div class="bd">
        <van-field
          v-model="form.phone"
          input-align="right"
          is-link
          label="手机号"
          label-class="new-cell"
          name="phone"
          placeholder="请填写手机号"
          required
          size="large"
        />
        <van-field
          v-model="form.wechat"
          input-align="right"
          is-link
          label="微信号"
          label-class="new-cell"
          name="wechat"
          placeholder="请填微信号"
          size="large"
        />
        <van-cell
          v-if="agreementData.NeedSign"
          class="go-agreement"
          is-link
          title="签署协议"
          :value="
            agreementData.NeedSign && agreementData.IsSigned
              ? '已签署'
              : '去签署'
          "
          @click="goAgreement"
        />
        <a
          href="javascript:;"
          style="
            color: #b57e48;
            text-align: center;
            padding: 14px;
            display: block;
          "
          @click="handelConfirm"
        >
          免费领取
        </a>
      </div>
    </div>
  </van-dialog>
</template>
<script>
  import store from '@/store'
  import { Toast } from 'vant'
  export default {
    props: {
      random: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        PackageName: '',
        submitLoading: false,
        selectItem: null,
        agreementData: {}, //签署协议需要
        // agreementTitle: '去签署',
        form: {
          wechat: '',
          phone: '',
        },
        showDialog: false,
      }
    },
    watch: {
      random: {
        handler() {
          // console.log('变化了')
          // console.log('selectItem', this.selectItem)
          if (this.selectItem) {
            this.isAgreement(this.selectItem)
          }
        },
        immediate: true,
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      //查询是否签署了协议
      isAgreement(item) {
        const loading = Toast.loading({
          duration: 0,
          message: '获取协议信息中...',
          forbidClick: true,
        })
        const param = {
          productId: item.ProdId,
        }
        store
          .dispatch('service/FormGetAgreementWithSignatureInfo', param)
          .then((data) => {
            const { Data, Code } = data
            if (Code === 0) {
              this.agreementData = Data
            }
          })
          .catch((e) => {
            Toast.fail(e.Message || '获取协议信息失败')
          })
          .finally(() => {
            loading.clear()
          })
      },
      goAgreement() {
        this.$router.push({
          path: '/agreement',
          query: {
            ProdId: this.selectItem.ProdId,
          },
        })
      },
      async show(productId) {
        //console.log('item', item)
        const product = await this.getProductDetail(productId).catch((e) => {
          Toast('获取产品信息失败')
        })
        this.showDialog = true
        this.selectItem = product
        this.isAgreement(product)
      },
      getProductDetail(productId) {
        return new Promise((resolve, reject) => {
          store
            .dispatch('service/GetDetail', {
              prodId: productId,
            })
            .then((data) => {
              resolve(data.Data)
            })
            .catch((e) => {
              reject(e)
            })
        })
      },
      init() {
        const query = this.$route.query
        const userInfo = store.getters['user/getUserInfo']
        this.form.wechat = userInfo.Wechat
        this.form.phone = userInfo.Phone
      },

      async handelConfirm() {
        const tenant = await store.getters['user/getTenant']
        if (this.agreementData.NeedSign && !this.agreementData.IsSigned) {
          Toast('请先签署协议')
          return
        }

        if (!this.form.phone.trim()) {
          Toast('请输入手机号码！')
          return
        }

        const query = this.$route.query
        store
          .dispatch('service/CreateOpenClassForm', {
            tenantId: tenant.TenantId,
            ProductId: this.selectItem.ProdId,
            wechat: this.form.wechat,
            phone: this.form.phone,
            channelId: query.channelId,
          })
          .then((data) => {
            const { Data } = data
            this.showDialog = false
            Toast.success('领取成功')
            setTimeout(() => {
              this.$router.push({
                name: 'ServiceContent',
                params: {
                  id: Data.FormId,
                },
              })
            }, 2000)
          })
          .catch((e) => {
            this.showDialog = false
            Toast(e.Message || '领取失败')
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .go-agreement {
    font-size: 15px;
    color: #646566;
    &:deep(.van-cell__value) {
      color: #323233;
    }
  }
</style>
